import '../../Styles/ReusableComponents/header.scss';

function Header(props) {
  return (
    <div className="header">
      <h1><span>{props.titleHighlighted}</span> {props.titleNeutral}</h1>
      <p>{props.text}</p>
      {props.children}
    </div>
  )
}

export default Header